/* eslint-disable indent */
import { logError } from '@log';
import { RETURN_ORDER_SERVICE_PATH } from '@constants';
import { request } from './request';

// 针对rc4.0登录页的逻辑api

/**
 * 登陆
 * @param {String} email 邮箱地址
 * @param {String} orderNumber 订单id
 */
export const getReturnLogin = async ({
  contactInfo,
  orderName,
  subDomain,
  merchantId,
  pathname,
  accessToken,
  channel,
  signature,
  forceDirect,
}, ...config) => {
  try {
    const resp = await request(pathname, {
      body: {
        contactInfo,
        orderName,
        subDomain,
        merchantId,
        accessToken,
        channel,
        signature,
        forceDirect,
      },
      path: RETURN_ORDER_SERVICE_PATH,
      ...config,
    });
    if (!resp) {
      return null;
    }
    return resp;
  } catch (error) {
    logError(error);
    return null;
  }
};

export const getShopNameUseful = async ({
  subDomain,
  channel,
  pathname,
}, ...config) => {
  try {
    const resp = await request(pathname, {
      body: {
        subDomain,
        channel,
      },
      path: RETURN_ORDER_SERVICE_PATH,
      ...config,
    });
    if (!resp) {
      return null;
    }
    return resp;
  } catch (error) {
    logError(error);
    return null;
  }
};

export const isVpnAccount = async ({
  seelPreviewCode,
  pathname,
}, ...config) => {
  try {
    const resp = await request(pathname, {
      body: {
        seelPreviewCode,
      },
      path: RETURN_ORDER_SERVICE_PATH,
      ...config,
    });
    if (!resp) {
      return null;
    }
    return resp;
  } catch (error) {
    logError(error);
    return null;
  }
};
